import React from "react";
import { FaCheck } from "react-icons/fa";

/*
    The green-ticked "Includes:" list.

    Shared by the four pricing tiers and the Static Data panel below them, so
    the tick, its colour and its spacing are defined once.

    FaCheck comes from react-icons, which is already a dependency and already
    the source of every other icon on this page (FaInfoCircle, FaPlusCircle).
    Cruip draws its own inline SVG; there is no reason to hand-roll one when
    the icon set is right here.

    A feature is either a plain string or `{ text, emphasis }`. `emphasis`
    marks the line as the tier's differentiator and is styled by the card it
    lands in — bold everywhere, and white on the dark tier — rather than
    carrying a colour of its own, which would be invisible on a light card.

    The <ul> is given no accessible name on purpose: the "Includes:" heading
    immediately above it is the label, and repeating it would have a screen
    reader announce the same words twice.
*/

/** Accepts "Report errors" or { text: "…", emphasis: true }. */
const normalise = (feature) =>
  typeof feature === "string" ? { text: feature, emphasis: false } : feature;

const FeatureList = ({ features = [], className = "" }) => {
  if (!features.length) return null;

  return (
    <ul className={`plan-features ${className}`}>
      {features.map((feature) => {
        const { text, emphasis } = normalise(feature);
        return (
          <li
            key={text}
            className={emphasis ? "plan-features__item--emphasis" : undefined}
          >
            <FaCheck className="plan-features__check" aria-hidden="true" />
            <span>{text}</span>
          </li>
        );
      })}
    </ul>
  );
};

export default FeatureList;
